// import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="push-notification"
import { BridgeComponent } from "@hotwired/hotwire-native-bridge";

export default class extends BridgeComponent {
  // This name MUST match exactly what you register in Android
  static component = "notification";

  promptUser() {
    // Send the "requestPermission" event to Android
    this.send("requestPermission", {}, (message) => {
      // This callback fires when Android replies via replyTo()
      if (message.data.granted) {
        console.log("Native Android successfully granted push permissions!");
        // Update web UI: e.g., this.element.classList.add("hidden")
      } else {
        console.log("User denied permissions on the native side.");
      }
    });
  }
}
